import {
  ChangeDetectorRef,
  Component,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { User } from '@wilson/interfaces';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'wilson-qualification-training-user-renderer',
  template: `{{ cellValue }}`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class QualificationTrainingUserRendererComponent
  implements AgRendererComponent
{
  private cdRef = inject(ChangeDetectorRef);

  public cellValue!: string;
  private user!: Pick<User, 'firstName' | 'lastName'>;

  async agInit(params: ICellRendererParams): Promise<void> {
    this.user = params.data?.user;
    this.cellValue = this.user
      ? `${this.user.firstName} ${this.user.lastName}`
      : 'Unknown User';
    this.cdRef.detectChanges();
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
